module.exports = __webpack_public_path__ + "img/47392E_997E69_7C6553_8B745F-256px.cdee3a81.png";